import { Reactive, ReactRouterConfig } from '@scfe-common/micro-frontend-utils';

import { $gt } from '../../common/appCtx';
import List from './attendance-history-data';

const config: ReactRouterConfig = {
  path: '/attendanceHistoryData',
  component: () => Reactive,
  meta: {
    title: $gt('Export'),
  },
  children: [
    {
      path: 'list',
      component: () => List,
      meta: {
        title: $gt('Attendance History Data'),
      },
    },
  ],
};

export default config;
